import { Divider, Grid, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import { useForm } from "react-hook-form";
import SwitchInput from "components/files/SwitchInput";
import CustomButton from "components/CustomButton";
import { useEffect, useState } from "react";
import { COLUMNS_LIST } from "../const";
import CheckRole from "components/CheckRole";
import NullCheck from "components/NullCheck";
import { getFromLocalStorage } from "config/functions";
import { GridViewOutlined, Toc } from "@mui/icons-material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const DisplaySettings = ({ open, setOpen, setDisplaySettings, isActive }) => {
  const { bt } = useBizTypeTranslation();
  const { handleSubmit, control, reset, formState: { errors } } = useForm();
  const [typeDisplay, setTypeDisplay] = useState("");

  useEffect(() => {
    const displaySettings = getFromLocalStorage("displaySettings");

    if (displaySettings) {
      setTypeDisplay(displaySettings?.type);
      reset(displaySettings);
    }
  }, []);

  const onSubmit = (values) => {
    const data = { type: typeDisplay, show: values?.show };
    localStorage.setItem("displaySettings", JSON.stringify(data));
    setDisplaySettings(data);
    setOpen(false);
  };

  const selectTypeDisplay = (type) => {
    setTypeDisplay(type);
  };

  return (
    <CustomDialog
      open={open}
      onClose={() => setOpen(false)}
      title="DISPLAY_SETTINGS"
      closeBtn='CLOSE'
      actionBtn={{ title: 'SAVE', onClick: () => handleSubmit(onSubmit)() }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack
          width="100%"
          padding={2}
          spacing={2}
        >
          <NullCheck valueForCheck={isActive}>
            <Stack spacing={1}>
              <Typography>{bt("DISPLAY_TYPE")}</Typography>
              <Stack direction="row" spacing={1}>
                <CustomButton
                  startIcon={<Toc sx={{ color: typeDisplay === "cards" ? "primary.main" : "bgPage.main" }} />}
                  title="TABLE"
                  variant={typeDisplay === "table" ? "contained" : "outlined"}
                  onClick={() => selectTypeDisplay("table")}
                />

                <CustomButton
                  title="CARDS"
                  startIcon={<GridViewOutlined sx={{ color: typeDisplay === "table" ? "primary.main" : "bgPage.main" }} />}
                  variant={typeDisplay === "cards" ? "contained" : "outlined"}
                  onClick={() => selectTypeDisplay("cards")}
                />
              </Stack>
            </Stack>

            <Divider />
          </NullCheck>

          <Stack spacing={1}>
            <Typography>{bt("SHOW_FIELD")}</Typography>
            <Grid container>
              {COLUMNS_LIST?.map((col, idx) => {
                return (
                  <CheckRole key={idx} role={col?.role}>
                    <Grid item xs={12} md={6}>
                      <Stack direction='row' spacing={2}>
                        <SwitchInput
                          title={col?.title}
                          name={`show.${col?.name}`}
                          width="100%"
                          errors={errors}
                          control={control}
                          defaultChecked={false}
                        />
                      </Stack>
                    </Grid>
                  </CheckRole>
                );
              })}
            </Grid>
          </Stack>

        </Stack>
      </form>
    </CustomDialog >
  );
};
export default DisplaySettings;
